/* SKAU Solutions – 3D-scener styret af scroll (Three.js hentes ved behov).
   Tre scener på samme motor: house (Sådan bygger vi), product (produktsider), company (forsiden).
   Tilstanden er en ren funktion af scrollposition. Al tekst er HTML. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var instances = new WeakMap();
  var libPromise = null;
  var COLORS = { acounteee: 0x5BC58B, compliance: 0x7FA6E8, vendors: 0x4DB8C2, people: 0xF2A25E, operations: 0x9298F4, cyber: 0xD0607F, suite: 0xB7BDC8 };
  var SUITE = [0x5BC58B, 0x7FA6E8, 0x4DB8C2, 0xF2A25E, 0x9298F4, 0xD0607F];
  var BUILD = {};

  function loadLib() {
    /* Three.js indlæses af et inline module-script i layoutet (Shopify omskriver import() i asset-filer). */
    if (!libPromise) {
      libPromise = new Promise(function (res, rej) {
        if (window.__skauLib) return res(window.__skauLib);
        window.addEventListener('skau-lib', function () { res(window.__skauLib); }, { once: true });
        window.addEventListener('skau-lib-fail', function () { rej(new Error('three kunne ikke hentes')); }, { once: true });
        setTimeout(function () { if (!window.__skauLib) rej(new Error('three timeout')); }, 20000);
      });
    }
    return libPromise;
  }
  function hasGL() {
    try { var c = document.createElement('canvas'); return !!(c.getContext('webgl2') || c.getContext('webgl')); }
    catch (e) { return false; }
  }
  function rng(seed) {
    return function () {
      seed |= 0; seed = seed + 0x6D2B79F5 | 0;
      var t = Math.imul(seed ^ seed >>> 15, 1 | seed);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }

  function boot(host) {
    if (instances.has(host)) return;
    if (reduce || !hasGL()) { host.classList.add('core--fail'); return; }
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      loadLib().then(function (lib) { instances.set(host, create(host, lib)); })
        .catch(function (err) { try { console.error('[skau-stage]', err); } catch (e) {} host.classList.add('core--fail'); });
    }, { rootMargin: '150% 0px' });
    io.observe(host);
    instances.set(host, { destroy: function () { io.disconnect(); } });
  }

  /* ================================================================== */
  function create(host, lib) {
    var THREE = lib.THREE;
    var kind = host.getAttribute('data-stage') || 'house';
    var key = host.getAttribute('data-key') || 'acounteee';
    var canvas = host.querySelector('.core__canvas');
    var pin = host.querySelector('.core__pin');
    var mobileMQ = window.matchMedia('(max-width: 899px)');
    var mobile = mobileMQ.matches;
    var SC = Math.max(2, parseInt(host.getAttribute('data-scenes'), 10) || 2);

    var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
    var lerp = function (a, b, t) { return a + (b - a) * t; };
    var ss = function (t) { t = clamp(t, 0, 1); return t * t * t * (t * (t * 6 - 15) + 10); };

    /* ---------- renderer, lys ---------- */
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
    renderer.setClearColor(0x000000, 0);
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.05;
    renderer.shadowMap.enabled = !mobile;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    var pixelCap = mobile ? 1.25 : 1.75;
    var pixelRatio = Math.min(window.devicePixelRatio || 1, pixelCap);

    var scene = new THREE.Scene();
    var pmrem = new THREE.PMREMGenerator(renderer);
    var envScene = new lib.RoomEnvironment();
    var envRT = pmrem.fromScene(envScene, 0.04);
    scene.environment = envRT.texture;
    var camera = new THREE.PerspectiveCamera(28, 1, 0.1, 160);

    var keyL = new THREE.DirectionalLight(0xffffff, 1.6);
    keyL.position.set(6, 10, 7);
    keyL.castShadow = !mobile;
    keyL.shadow.mapSize.set(1024, 1024);
    keyL.shadow.camera.left = -10; keyL.shadow.camera.right = 10; keyL.shadow.camera.top = 10; keyL.shadow.camera.bottom = -10;
    keyL.shadow.camera.near = 1; keyL.shadow.camera.far = 40;
    keyL.shadow.radius = 5; keyL.shadow.bias = -0.0004;
    scene.add(keyL);
    scene.add(new THREE.HemisphereLight(0xdfe8f5, 0x0b0f14, 0.55));
    var rim = new THREE.DirectionalLight(0x9fd0ff, 0.7);
    rim.position.set(-6, 3, -5);
    scene.add(rim);
    var ground = new THREE.Mesh(new THREE.PlaneGeometry(80, 80), new THREE.ShadowMaterial({ opacity: 0.38 }));
    ground.rotation.x = -Math.PI / 2; ground.position.y = -0.005; ground.receiveShadow = true;
    scene.add(ground);

    /* ---------- materialer og hjælpere ---------- */
    var disposables = [ground.geometry, ground.material];
    function brushedTexture() {
      var c = document.createElement('canvas'); c.width = 256; c.height = 256;
      var g = c.getContext('2d');
      for (var y = 0; y < 256; y++) { var v = 120 + Math.floor(Math.random() * 90); g.fillStyle = 'rgb(' + v + ',' + v + ',' + v + ')'; g.fillRect(0, y, 256, 1); }
      var t = new THREE.CanvasTexture(c); t.wrapS = t.wrapT = THREE.RepeatWrapping; t.repeat.set(2, 2); return t;
    }
    var brushed = brushedTexture(); disposables.push(brushed);
    var mkMat = function (m, env) {
      m.userData.c = m.color.clone(); m.userData.ei = m.emissiveIntensity || 0; m.userData.env = env || 1; m.envMapIntensity = m.userData.env;
      disposables.push(m); return m;
    };
    var palette = {
      ceramic: function () { return mkMat(new THREE.MeshPhysicalMaterial({ color: 0xe6e4de, roughness: 0.36, metalness: 0, clearcoat: 0.6, clearcoatRoughness: 0.3 })); },
      graphite: function () { return mkMat(new THREE.MeshStandardMaterial({ color: 0x38414b, roughness: 0.42, metalness: 0.55 }), 1.7); },
      metal: function () { return mkMat(new THREE.MeshStandardMaterial({ color: 0xb9bfc8, roughness: 0.42, metalness: 1, roughnessMap: brushed })); },
      dark: function () { return mkMat(new THREE.MeshStandardMaterial({ color: 0x10151b, roughness: 0.22, metalness: 0.3 }), 1.4); },
      glow: function (hex, ei) { return mkMat(new THREE.MeshStandardMaterial({ color: hex, emissive: hex, emissiveIntensity: ei == null ? 0.9 : ei, roughness: 0.4 })); }
    };
    var boxCache = {};
    function boxGeo(w, h, d) { var k = w + '|' + h + '|' + d; return boxCache[k] || (boxCache[k] = (function () { var g = new THREE.BoxGeometry(w, h, d); disposables.push(g); return g; })()); }
    function box(mat, w, h, d, x, y, z, parent) {
      var m = new THREE.Mesh(boxGeo(w, h, d), mat); m.position.set(x, y, z); m.castShadow = m.receiveShadow = !mobile; if (parent) parent.add(m); return m;
    }
    var cylG = new THREE.CylinderGeometry(1, 1, 1, 28); disposables.push(cylG);
    function cyl(mat, r, h, x, y, z, parent) {
      var m = new THREE.Mesh(cylG, mat); m.scale.set(r, h, r); m.position.set(x, y, z); m.castShadow = !mobile; if (parent) parent.add(m); return m;
    }
    function hcyl(mat, r, len, x, y, z, parent, alongZ) {
      var m = cyl(mat, r, len, x, y, z, parent); if (alongZ) m.rotation.x = Math.PI / 2; else m.rotation.z = Math.PI / 2; return m;
    }
    function track() { for (var i = 0; i < arguments.length; i++) disposables.push(arguments[i]); }
    function dimGroup(g, k) {
      var bg = 0.045;
      (g.userData.mats || []).forEach(function (m) {
        var c = m.userData.c;
        m.color.setRGB(lerp(bg, c.r, k), lerp(bg, c.g, k), lerp(bg, c.b, k));
        m.envMapIntensity = lerp(0.12, 1, k) * m.userData.env;
        if (m.userData.ei) m.emissiveIntensity = m.userData.ei * (0.35 + 0.65 * k);
      });
    }

    var ctx = {
      THREE: THREE, lib: lib, scene: scene, palette: palette, box: box, cyl: cyl, hcyl: hcyl, track: track,
      clamp: clamp, lerp: lerp, ss: ss, mobile: mobile, key: key, SC: SC, rng: rng, dimGroup: dimGroup,
      accent: COLORS[key] || 0x9be0d3, host: host, mkMat: mkMat
    };
    var B = (BUILD[kind] || BUILD.house)(ctx);

    /* ---------- DOM-lag ---------- */
    var caps = [].slice.call(host.querySelectorAll('.core__text .sc'));
    var tagEls = [].slice.call(host.querySelectorAll('[data-anchor]'));
    var countEl = host.querySelector('[data-count]');
    var lastCount = -1;
    var tags = tagEls.map(function (el) {
      var scenes = (el.getAttribute('data-scene') || '').split(',').map(function (x) { return parseInt(x, 10) - 1; });
      return { el: el, key: el.getAttribute('data-anchor'), scenes: scenes, isLink: el.classList.contains('core__link') };
    });

    /* ---------- størrelse ---------- */
    var vw = 0, vh = 0;
    function resize() {
      mobile = mobileMQ.matches; ctx.mobile = mobile;
      var r = pin.getBoundingClientRect();
      vw = Math.max(1, Math.round(r.width));
      vh = Math.max(1, Math.round(mobile ? r.height * 0.62 : r.height));
      renderer.setPixelRatio(pixelRatio);
      renderer.setSize(vw, vh, false);
      camera.aspect = vw / vh;
      if (mobile) camera.clearViewOffset(); else camera.setViewOffset(vw, vh, -vw * 0.11, 0, vw, vh);
      camera.fov = vw / vh < 1 ? 38 : 28;
      camera.updateProjectionMatrix();
    }
    var ro = new ResizeObserver(resize); ro.observe(pin);
    resize();

    var tmp = new THREE.Vector3(), tgt = new THREE.Vector3(), cam = new THREE.Vector3();
    var camA = [0, 0, 0], tgtA = [0, 0, 0];
    var t0 = performance.now();

    function frameCam(u) {
      var K = B.K;
      if (B.camera) { B.camera(u, camA, tgtA); return; }
      u = clamp(u, 0, SC - 1);
      var i = Math.min(Math.floor(u), SC - 2), f = u - i, g = ss((f - 0.25) / 0.5);
      for (var c = 0; c < 3; c++) { camA[c] = lerp(K[i].cam[c], K[i + 1].cam[c], g); tgtA[c] = lerp(K[i].tgt[c], K[i + 1].tgt[c], g); }
    }

    var cur = 0, target = 0, running = false, visible = false, raf = 0, disposed = false;
    var frames = 0, tAcc = 0, lastT = 0;

    function measure() {
      var r = host.getBoundingClientRect();
      var top = parseFloat(getComputedStyle(pin).top) || 0;
      target = clamp((top - r.top) / Math.max(1, r.height - pin.offsetHeight), 0, 1);
    }

    function render(p, now) {
      var time = (now - t0) / 1000;
      var u = p * SC - 0.5;
      B.update(u, time);
      frameCam(u);
      tgt.set(tgtA[0], tgtA[1], tgtA[2]);
      var nw = camera.aspect < 1 ? 1 + (1 - camera.aspect) * 0.9 : 1;
      var sway = (1 - ss(u / 0.8)) * 0.07;
      cam.set(tgtA[0] + (camA[0] - tgtA[0]) * nw * 1.05 + Math.sin(time * 0.4) * sway,
              tgtA[1] + (camA[1] - tgtA[1]) * nw * 1.05 + Math.sin(time * 0.33) * sway * 0.5,
              tgtA[2] + (camA[2] - tgtA[2]) * nw * 1.05);
      camera.position.copy(cam); camera.lookAt(tgt);

      var activeScene = 0;
      for (var s2 = 0; s2 < SC; s2++) {
        var sw = ss(clamp((0.5 - Math.abs(u - s2)) / 0.22, 0, 1));
        if (sw > 0.5) activeScene = s2;
        var el = caps[s2];
        if (el) { el.style.opacity = sw.toFixed(3); el.style.transform = 'translateY(' + ((1 - sw) * 14).toFixed(1) + 'px)'; el.classList.toggle('on', sw > 0.5); el.style.visibility = sw > 0.01 ? 'visible' : 'hidden'; }
      }
      if (countEl && lastCount !== activeScene) { countEl.textContent = ('0' + (activeScene + 1)).slice(-2); lastCount = activeScene; }
      host.style.setProperty('--p', p.toFixed(4));
      renderer.render(scene, camera);

      var hw = vw / 2, hh = vh / 2;
      tags.forEach(function (t) {
        var sw2 = 0;
        for (var z = 0; z < t.scenes.length; z++) sw2 = Math.max(sw2, ss(clamp((0.5 - Math.abs(u - t.scenes[z])) / 0.22, 0, 1)));
        t.el.style.opacity = sw2.toFixed(3);
        t.el.style.visibility = sw2 > 0.01 ? 'visible' : 'hidden';
        if (t.isLink) t.el.classList.toggle('is-hit', sw2 > 0.8);
        if (vw < 560 && (t.key.indexOf('mini:') === 0 || t.key.indexOf('room:') === 0)) { t.el.style.visibility = 'hidden'; return; }
        if (sw2 <= 0.01) return;
        if (!B.anchor(t.key, tmp)) { t.el.style.visibility = 'hidden'; return; }
        tmp.project(camera);
        var x = tmp.x * hw + hw, y = -tmp.y * hh + hh;
        t.el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + (y - (t.isLink ? 12 : 8)).toFixed(1) + 'px,0)';
      });
    }

    function loop(now) {
      if (disposed) return;
      raf = 0;
      measure();
      var d = target - cur;
      var dt = lastT ? Math.min(250, now - lastT) : 16;
      cur = Math.abs(d) < 0.0004 ? target : cur + d * (1 - Math.exp(-dt / 90));
      render(cur, now);
      if (lastT) {
        tAcc += now - lastT; frames++;
        if (frames === 45) {
          if (tAcc / frames > 30 && pixelRatio > 1) { pixelRatio = Math.max(1, pixelRatio - 0.25); resize(); }
          frames = 0; tAcc = 0;
        }
      }
      lastT = now;
      if (visible && !document.hidden) raf = requestAnimationFrame(loop); else running = false;
    }
    function kick() { if (!running && visible && !disposed) { running = true; lastT = 0; raf = requestAnimationFrame(loop); } }
    var io = new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) kick(); }, { rootMargin: '10% 0px' });
    io.observe(host);
    var onVis = function () { if (!document.hidden) kick(); };
    document.addEventListener('visibilitychange', onVis);

    measure(); cur = target; render(cur, performance.now());
    host.classList.add('core--ready');

    return {
      destroy: function () {
        disposed = true; cancelAnimationFrame(raf); io.disconnect(); ro.disconnect();
        document.removeEventListener('visibilitychange', onVis);
        disposables.forEach(function (d) { try { d.dispose(); } catch (e) {} });
        envRT.dispose(); pmrem.dispose(); renderer.dispose(); renderer.forceContextLoss && renderer.forceContextLoss();
        host.classList.remove('core--ready');
      },
      set: function (p) { cur = target = p; render(p, performance.now()); }
    };
  }

  /* ================================================================== */
  /* HUS: bygges lag for lag, åbnes og viser produkterne som rum        */
  /* ================================================================== */
  BUILD.house = function (c) {
    var T = c.THREE, P = c.palette, box = c.box, cyl = c.cyl, hcyl = c.hcyl, scene = c.scene;
    var clamp = c.clamp, lerp = c.lerp, ss = c.ss;
    var W = 4.2, D = 3.0, FH = 2.5, RISE = 1.1;
    var L = [];
    function layer() { var g = new T.Group(); g.userData.mats = []; scene.add(g); L.push(g); return g; }
    function use(g, m) { g.userData.mats.push(m); return m; }
    function tint(m, hex) { m.color.setHex(hex); m.userData.c = m.color.clone(); return m; }
    function lineMat(hex, op) { var m = new T.LineBasicMaterial({ color: hex, transparent: true, opacity: op }); c.track(m); return m; }

    /* 0 · Infrastructure: fundament og pæle */
    var g0 = layer();
    box(use(g0, P.metal()), W + 0.9, 0.22, D + 0.9, 0, -0.11, 0, g0);
    [-1.8, 0, 1.8].forEach(function (x) { [-1.1, 1.1].forEach(function (z) { cyl(use(g0, P.graphite()), 0.14, 0.7, x, -0.55, z, g0); }); });
    for (var k = 0; k < 6; k++) box(use(g0, P.glow(0x5BC58B, 0.85)), 0.3, 0.012, 0.04, (k - 2.5) * 0.4, 0.006, (D + 0.9) / 2 - 0.1, g0).material.color.setHex([0x5BC58B, 0x7FA6E8, 0x4DB8C2, 0xF2A25E, 0x9298F4, 0xD0607F][k]);
    g0.children.slice(-6).forEach(function (m, i) { var col = [0x5BC58B, 0x7FA6E8, 0x4DB8C2, 0xF2A25E, 0x9298F4, 0xD0607F][i]; m.material.emissive.setHex(col); m.material.userData.c = m.material.color.clone(); });

    /* 1 · Security: bærende stel, afgrænsning og kontroltråd */
    var g1 = layer(); var gm = use(g1, P.graphite());
    [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(function (p) { box(gm, 0.14, FH, 0.14, p[0] * (W / 2 - 0.07), FH / 2, p[1] * (D / 2 - 0.07), g1); });
    [-1, 1].forEach(function (s) { box(gm, 0.1, FH, 0.1, 0, FH / 2, s * (D / 2 - 0.05), g1); });
    [-1, 1].forEach(function (s) { box(gm, W, 0.12, 0.12, 0, FH, s * (D / 2 - 0.06), g1); box(gm, 0.12, 0.12, D, s * (W / 2 - 0.06), FH, 0, g1); box(gm, 0.1, 0.1, D, s * (W / 2 - 0.06), 1.25, 0, g1); });
    var fenceG = new T.BufferGeometry(); var fw = (W + 1.7) / 2, fd = (D + 1.7) / 2;
    fenceG.setFromPoints([new T.Vector3(-fw, 0.02, -fd), new T.Vector3(fw, 0.02, -fd), new T.Vector3(fw, 0.02, fd), new T.Vector3(-fw, 0.02, fd)]);
    var fence = new T.LineLoop(fenceG, lineMat(0x9be0d3, 0.7)); g1.add(fence); c.track(fenceG);
    var thread = cyl(use(g1, P.glow(0xd7efe9, 1.0)), 0.02, FH + 0.4, -(W / 2 - 0.07), (FH + 0.4) / 2, D / 2 - 0.07, g1);
    var thr = thread;

    /* 2 · Integrations: forsyningslinjer ind og ud */
    var g2 = layer(); var pm = use(g2, P.metal());
    var pipes = [];
    [-0.9, 0, 0.9].forEach(function (z, k) {
      hcyl(pm, 0.05, W + 3.8, 0, 0.2, z, g2);
      [-1, 1].forEach(function (s) {
        box(pm, 0.34, 0.22, 0.34, s * (W / 2 + 1.95), 0.2, z, g2);
        box(use(g2, P.glow(SUITE[(k * 2 + (s > 0 ? 1 : 0)) % 6], 0.9)), 0.05, 0.12, 0.18, s * (W / 2 + 1.95 + (s > 0 ? -0.2 : 0.2)), 0.2, z, g2);
      });
      pipes.push(z);
    });
    box(pm, 0.46, 0.2, 0.46, 0, 0.2, 0, g2);
    [-1.5, 1.5].forEach(function (x) { cyl(pm, 0.04, 2.0, x, 1.2, -D / 2 + 0.25, g2); box(pm, 0.14, 0.1, 0.14, x, 0.2, -D / 2 + 0.25, g2); });

    /* 3 · Data: lagerskab af plader */
    var g3 = layer();
    for (var d = 0; d < 6; d++) {
      box(use(g3, d % 2 ? P.metal() : P.graphite()), 1.7, 0.09, 1.05, -1.0, 0.32 + d * 0.19, -0.6, g3);
      box(use(g3, P.glow(0x9be0d3, 0.6)), 1.1, 0.012, 0.03, -1.0, 0.32 + d * 0.19 + 0.05, -0.05, g3);
    }
    box(use(g3, P.dark()), 1.6, 1.15, 0.02, -1.0, 0.85, -1.14, g3);

    /* 4 · AI & Automation: styreenhed med menneskelig godkendelse */
    var g4 = layer();
    cyl(use(g4, P.graphite()), 0.42, 1.55, 1.2, 0.78, -0.6, g4);
    cyl(use(g4, P.ceramic()), 0.32, 0.05, 1.2, 1.58, -0.6, g4);
    var ring = new T.Mesh(new T.TorusGeometry(0.46, 0.022, 10, 48), use(g4, P.glow(0x9be0d3, 0.8))); ring.rotation.x = Math.PI / 2; ring.position.set(1.2, 1.05, -0.6); g4.add(ring); c.track(ring.geometry);
    var halo = new T.Mesh(new T.TorusGeometry(0.34, 0.03, 10, 40), use(g4, P.glow(0xffffff, 0.9))); halo.rotation.x = Math.PI / 2; halo.position.set(1.2, 2.0, -0.6); g4.add(halo); c.track(halo.geometry);
    var haloStem = cyl(use(g4, P.metal()), 0.012, 0.4, 1.2, 1.8, -0.6, g4);

    /* 5 · Application: forretningslogik, flow og rum */
    var g5 = layer(); var wm = use(g5, P.graphite());
    box(wm, 1.55, 1.15, 0.06, -1.15, 0.58, 0.45, g5); box(wm, 1.55, 1.15, 0.06, 1.15, 0.58, 0.45, g5);
    var padM = use(g5, P.glow(0x9be0d3, 0.45));
    [-1.2, 0, 1.2].forEach(function (x) { box(padM, 0.55, 0.03, 0.55, x, 0.04, 1.0, g5); });
    box(use(g5, P.metal()), 2.4, 0.015, 0.03, 0, 0.06, 1.0, g5);

    /* 6 · Experience: facade, vinduer, dør og tag */
    var g6 = layer(); var cer = tint(use(g6, P.ceramic()), 0xd9d6cf), glass = use(g6, P.metal()), roofM = tint(use(g6, P.graphite()), 0x3d464f);
    glass.color.setHex(0x0b1117); glass.roughness = 0.08; glass.metalness = 0.9; glass.emissive = new T.Color(0x9be0d3); glass.emissiveIntensity = 0; glass.userData.c = glass.color.clone();
    var frameM = use(g6, P.metal());
    var gF = new T.Group(); g6.add(gF); gF.position.set(-W / 2, 0, 0);
    var gS = new T.Group(); g6.add(gS);
    var gRoof = new T.Group(); g6.add(gRoof);
    box(cer, W + 0.06, FH, 0.07, W / 2, FH / 2, D / 2 + 0.035, gF);
    [[W / 2 - 1.35, 1.5, 1.0, 1.1], [W / 2 + 1.35, 1.5, 1.0, 1.1], [W / 2, 0.98, 0.95, 1.95]].forEach(function (w) { box(frameM, w[2] + 0.1, w[3] + 0.1, 0.03, w[0], w[1], D / 2 + 0.075, gF); box(glass, w[2], w[3], 0.02, w[0], w[1], D / 2 + 0.095, gF); });
    box(frameM, 0.05, 0.3, 0.04, W / 2 + 0.3, 1.0, D / 2 + 0.12, gF);
    var gabShape = new T.Shape(); gabShape.moveTo(-W / 2 - 0.35, 0); gabShape.lineTo(W / 2 + 0.35, 0); gabShape.lineTo(0, RISE); gabShape.closePath();
    var gabG = new T.ExtrudeGeometry(gabShape, { depth: 0.07, bevelEnabled: false }); c.track(gabG);
    var gabF = new T.Mesh(gabG, cer); gabF.position.set(W / 2, FH, D / 2); gF.add(gabF);
    var gabB = new T.Mesh(gabG, cer); gabB.position.set(0, FH, -D / 2 - 0.07); gS.add(gabB);
    box(cer, W + 0.06, FH, 0.07, 0, FH / 2, -D / 2 - 0.035, gS);
    [-1, 1].forEach(function (s) {
      box(cer, 0.07, FH, D + 0.14, s * (W / 2 + 0.035), FH / 2, 0, gS);
      box(frameM, 0.03, 1.2, 1.1, s * (W / 2 + 0.075), 1.5, 0.1, gS); box(glass, 0.02, 1.1, 1.0, s * (W / 2 + 0.095), 1.5, 0.1, gS);
    });
    var hs = W / 2 + 0.35, slen = Math.sqrt(hs * hs + RISE * RISE) + 0.05, ang = Math.atan2(RISE, hs);
    [-1, 1].forEach(function (s) {
      var m = box(roofM, slen, 0.1, D + 0.5, s * hs / 2, FH + RISE / 2 + 0.05, 0, gRoof); m.rotation.z = -s * ang;
    });
    for (var rr = 0; rr < 6; rr++) {
      var ridge = box(use(g6, P.glow(SUITE[rr], 0.85)), 0.05, 0.05, 0.4, 0, FH + RISE + 0.12, (rr - 2.5) * 0.5, gRoof);
      ridge.material.color.setHex(SUITE[rr]); ridge.material.emissive.setHex(SUITE[rr]); ridge.material.userData.c = ridge.material.color.clone();
    }

    /* produkternes rum (vises, når huset åbnes) */
    var rooms = new T.Group(); scene.add(rooms);
    var roomMeshes = [];
    var rshell = P.graphite(), rfloor = P.metal();
    box(rfloor, W - 0.3, 0.06, D - 0.5, 0, 1.12, -0.1, rooms);
    var sphG = new T.SphereGeometry(0.14, 16, 12), conG = new T.ConeGeometry(0.11, 0.36, 12), capG = new T.CapsuleGeometry(0.11, 0.24, 4, 10), headG = new T.SphereGeometry(0.095, 14, 10), torG = new T.TorusGeometry(0.2, 0.014, 8, 28);
    c.track(sphG, conG, capG, headG, torG);
    for (var q = 0; q < 6; q++) {
      var rg = new T.Group(); var col = SUITE[q];
      var cx = ((q % 3) - 1) * 1.35, cy = q < 3 ? 0.55 : 1.7;
      rg.position.set(cx, cy, -0.1);
      var shell = P.graphite(), lit = P.glow(col, 0.9), ceram = P.ceramic(), met = P.metal();
      box(shell, 1.1, 0.04, 1.3, 0, -0.43, 0, rg); box(shell, 1.1, 0.04, 1.3, 0, 0.43, 0, rg);
      box(shell, 0.04, 0.86, 1.3, -0.53, 0, 0, rg); box(shell, 0.04, 0.86, 1.3, 0.53, 0, 0, rg);
      box(shell, 1.1, 0.86, 0.04, 0, 0, -0.63, rg);
      var back = P.glow(col, 0.28); box(back, 0.9, 0.62, 0.012, 0, 0, -0.6, rg);
      box(lit, 1.06, 0.03, 0.03, 0, 0.4, 0.64, rg); box(lit, 0.5, 0.02, 0.03, 0, -0.4, 0.64, rg);
      var fy = -0.4;
      if (q === 0) { [0, 1, 2].forEach(function (z) { box(ceram, 0.46, 0.03, 0.6, -0.1, fy + 0.02 + z * 0.045, 0.05, rg).rotation.y = z * 0.12; }); cyl(met, 0.15, 0.035, 0.3, fy + 0.03, 0.25, rg); cyl(met, 0.15, 0.035, 0.3, fy + 0.07, 0.25, rg); box(lit, 0.1, 0.012, 0.1, -0.1, fy + 0.15, 0.05, rg); }
      else if (q === 1) { box(ceram, 0.5, 0.56, 0.03, 0, fy + 0.3, 0, rg); box(lit, 0.16, 0.16, 0.035, 0.1, fy + 0.42, 0.01, rg); box(lit, 0.3, 0.025, 0.036, -0.02, fy + 0.2, 0.01, rg); box(lit, 0.3, 0.025, 0.036, -0.02, fy + 0.12, 0.01, rg); }
      else if (q === 2) { box(lit, 1.0, 0.02, 0.05, 0, fy + 0.02, 0.35, rg); [-0.3, 0, 0.3].forEach(function (x, k) { box(ceram, 0.26, 0.2 + k * 0.05, 0.26, x, fy + 0.12 + k * 0.025, 0.05, rg); cyl(lit, 0.012, 0.3, x, fy + 0.2, 0.35, rg); }); }
      else if (q === 3) { [-0.25, 0.1, 0.35].forEach(function (x, k) { var b = new T.Mesh(capG, ceram), h = new T.Mesh(headG, ceram); b.position.set(x, fy + 0.25, 0.05 - k * 0.08); h.position.set(x, fy + 0.5, 0.05 - k * 0.08); rg.add(b); rg.add(h); if (k === 1) box(lit, 0.08, 0.08, 0.02, x, fy + 0.3, 0.17 - k * 0.08, rg); }); }
      else if (q === 4) { [-0.3, 0.05, 0.4].forEach(function (x) { box(ceram, 0.2, 0.2, 0.2, x, fy + 0.12, 0.15, rg); }); box(met, 0.04, 0.5, 0.04, -0.14, fy + 0.27, 0.15, rg); box(met, 0.04, 0.5, 0.04, 0.2, fy + 0.27, 0.15, rg); box(lit, 0.4, 0.03, 0.03, 0.03, fy + 0.52, 0.15, rg); }
      else { [-0.32, 0.0, 0.32].forEach(function (x, k) { var n = new T.Mesh(k === 1 ? conG : sphG, k === 1 ? lit : met); n.position.set(x, fy + (k === 1 ? 0.2 : 0.15), 0.1); rg.add(n); }); var tr = new T.Mesh(torG, lit); tr.rotation.x = Math.PI / 2; tr.position.set(0, fy + 0.03, 0.1); tr.scale.set(1.6, 1.6, 1.6); rg.add(tr); }
      rooms.add(rg); roomMeshes.push(rg);
    }
    var tieG = new T.BufferGeometry();
    var tieP = [];
    for (var a = 0; a < 6; a++) { var ra = roomMeshes[a].position; if (a % 3 < 2) { var rb = roomMeshes[a + 1].position; tieP.push(ra.x + 0.55, ra.y, ra.z + 0.7, rb.x - 0.55, rb.y, rb.z + 0.7); } if (a < 3) { var rc = roomMeshes[a + 3].position; tieP.push(ra.x, ra.y + 0.43, ra.z + 0.7, rc.x, rc.y - 0.43, rc.z + 0.7); } }
    tieG.setAttribute('position', new T.BufferAttribute(new Float32Array(tieP), 3)); c.track(tieG);
    var tieM = lineMat(0x9be0d3, 0); var ties = new T.LineSegments(tieG, tieM); ties.frustumCulled = false; rooms.add(ties);

    /* byggeplads og dataprikker */
    var gridG = new T.BufferGeometry(), gp = [];
    for (var i = -6; i <= 6; i++) { gp.push(i, 0.003, -6, i, 0.003, 6, -6, 0.003, i, 6, 0.003, i); }
    gridG.setAttribute('position', new T.BufferAttribute(new Float32Array(gp), 3)); c.track(gridG);
    var gridM = lineMat(0x3b4752, 0); var grid = new T.LineSegments(gridG, gridM); scene.add(grid);
    var dotG = new T.SphereGeometry(0.045, 10, 10), dotM = new T.MeshBasicMaterial({ color: 0xcdf3ea }); c.track(dotG, dotM);
    var NDOT = 18, dots = new T.InstancedMesh(dotG, dotM, NDOT); dots.frustumCulled = false; scene.add(dots);
    var dum = new T.Object3D();

    var K = [
      { cam: [7.5, 4.2, 9.5], tgt: [0, 1.5, 0] },
      { cam: [4.4, 2.1, 8.0], tgt: [0.5, 1.3, 1.6] },
      { cam: [8, 5.5, 10.5], tgt: [0, 0.6, 0] },
      { cam: [5.6, 3.0, 7.4], tgt: [0, 0.1, 0] },
      { cam: [-5.8, 3.8, 7.6], tgt: [0, 1.3, 0] },
      { cam: [0.8, 3.2, 10.8], tgt: [0, 0.4, 0] },
      { cam: [-5.6, 3.0, 6.4], tgt: [-2.6, 0.9, -0.5] },
      { cam: [5.0, 3.0, 6.4], tgt: [0.2, 1.1, -0.5] },
      { cam: [0.9, 5.2, 8.4], tgt: [-0.4, 0.9, 0.3] },
      { cam: [6.5, 3.2, 8.6], tgt: [0, 1.5, 0] },
      { cam: [8.0, 3.8, 10.5], tgt: [0, 1.6, 0] },
      { cam: [1.5, 3.2, 9.6], tgt: [0, 1.2, 0] },
      { cam: [0, 5.2, 13.5], tgt: [0, 1.0, 0] }
    ];
    var focusScene = [3, 4, 5, 6, 7, 8, 9]; /* lag i bygge-rækkefølge */

    function update(u, time) {
      var fin = 1 - ss((u - 1.3) / 0.8);
      var open = ss((u - 10.7) / 0.9);
      var buildPhase = ss((u - 2.5) / 0.6) * (1 - ss((u - 9.6) / 0.6));
      for (var i = 0; i < 7; i++) {
        var b = ss((u - (2.35 + i)) / 0.75);
        var vis = Math.max(fin, b);
        var g = L[i];
        var sc = (i >= 3 && i <= 5) ? 1 - open : 1;
        g.visible = vis > 0.004 && sc > 0.01;
        g.position.y = (1 - vis) * 5.5;
        g.scale.setScalar(Math.max(0.0001, sc));
        var a = ss(clamp((0.9 - Math.abs(u - (3 + i))) / 0.5, 0, 1));
        dimGroupLocal(g, 1 - 0.32 * (1 - a) * buildPhase);
      }
      gF.scale.y = Math.max(0.0001, 1 - open);
      gRoof.position.y = open * 3.4;
      glass.emissiveIntensity = 0.5 * ss((u - 9.6) / 0.7);
      thr.material.emissiveIntensity = 0.6 + 0.5 * Math.sin(time * 2.2);
      ring.rotation.z = time * 0.6; halo.position.y = 2.0 + Math.sin(time * 1.4) * 0.03;
      var rv = ss((u - 10.7) / 0.8);
      rooms.visible = rv > 0.003;
      roomMeshes.forEach(function (rg, k) {
        var s = ss(clamp(rv * 1.5 - k * 0.1, 0, 1));
        rg.scale.setScalar(Math.max(0.0001, s));
      });
      tieM.opacity = 0.65 * ss((u - 11.5) / 0.6);
      gridM.opacity = 0.55 * (1 - Math.max(fin, ss((u - 3.1) / 0.5)));
      grid.visible = gridM.opacity > 0.01;
      /* dataprikker langs forsyningslinjer */
      var dw = Math.max(0, ss((u - 4.6) / 0.6)) * (1 - 0.7 * ss((u - 10.2) / 0.6)) * (u > 4 ? 1 : 0);
      for (var q = 0; q < NDOT; q++) {
        var pz = pipes[q % 3], uu = ((q / NDOT) * 3 + time * 0.12) % 1;
        dum.position.set(lerp(-(W / 2 + 1.95), W / 2 + 1.95, q % 2 ? uu : 1 - uu), 0.3, pz);
        dum.scale.setScalar(Math.max(0.0001, dw * Math.sin(uu * Math.PI)));
        dum.updateMatrix(); dots.setMatrixAt(q, dum.matrix);
      }
      dots.instanceMatrix.needsUpdate = true;
    }
    function dimGroupLocal(g, k) { c.dimGroup(g, k); }

    var AN = {
      'found': [W / 2 + 0.45, 0.0, D / 2 + 0.45], 'pile': [1.8, -0.7, 1.15],
      'fence': [W / 2 + 0.85, 0.02, -0.4], 'door': [0, 1.0, D / 2 + 0.3], 'thread': [-(W / 2 - 0.07), FH + 0.35, D / 2 - 0.07],
      'in': [-(W / 2 + 1.95), 0.4, 0], 'hub': [0, 0.45, 0], 'out': [W / 2 + 1.95, 0.4, 0],
      'dsrc': [-2.0, 0.6, 0.0], 'dstruct': [-1.0, 1.55, -0.1], 'dapp': [0.1, 0.9, -1.1],
      'aip': [0.2, 1.05, -0.1], 'aihum': [1.2, 2.15, -0.6], 'aiprop': [1.2, 1.1, 0.0],
      'pin': [-1.2, 0.15, 1.0], 'pproc': [0, 0.15, 1.0], 'pres': [1.2, 0.15, 1.0],
      'face': [-W / 2, 1.9, D / 2 + 0.1], 'roof': [W / 2, FH + RISE * 0.6, 0.0], 'win': [W / 2 - 0.2, 1.5, D / 2 + 0.2],
      'suite': [0, 3.2, 0]
    };
    function anchor(k, out) {
      if (k.indexOf('room:') === 0) { var rm = roomMeshes[+k.slice(5)]; if (!rm) return false; return out.set(rm.position.x, rm.position.y + 0.55, rm.position.z + 0.7), true; }
      var a = AN[k]; if (!a) return false; out.set(a[0], a[1], a[2]); return true;
    }
    return { K: K, update: update, anchor: anchor };
  };

  /* ================================================================== */
  /* PRODUKT: input → modul → resultat → illustreret dashboard           */
  /* ================================================================== */
  BUILD.product = function (c) {
    var T = c.THREE, P = c.palette, box = c.box, cyl = c.cyl, scene = c.scene, key = c.key, acc = c.accent;
    var clamp = c.clamp, lerp = c.lerp, ss = c.ss, rnd = c.rng(key.length * 97 + 11);
    var accCol = new T.Color(acc);

    /* sokkel */
    var plate = box(P.graphite(), 12, 0.2, 5.6, 0.4, -0.1, 0, scene);
    box(P.glow(acc, 0.8), 11.6, 0.012, 0.04, 0.4, 0.004, 2.65, scene);

    /* modulet: syv lag, som i Software Core */
    var mod = new T.Group(); mod.position.set(1.15, 0, 0); scene.add(mod);
    var slabs = [], strips = [];
    for (var i = 0; i < 7; i++) {
      var sm = i === 6 ? P.ceramic() : (i === 3 ? P.metal() : P.graphite());
      var s = box(sm, 1.9, 0.15, 1.4, 0, 0.12 + i * 0.17, 0, mod); slabs.push(s);
      var gm = P.glow(acc, 0.6); strips.push(gm);
      box(gm, 1.2, 0.012, 0.035, 0.1, 0.12 + i * 0.17 + 0.076, 0.58, mod);
    }
    box(P.dark(), 0.04, 0.4, 0.5, -0.96, 0.5, 0, mod); box(P.dark(), 0.04, 0.4, 0.5, 0.96, 0.5, 0, mod);

    /* objekter */
    var N = key === 'suite' ? 6 : 16, items = [];
    var matDoc = P.ceramic(), matLine = P.dark(), matCoin = P.metal(), matBody = P.ceramic();
    function docGroup() {
      var g = new T.Group(); box(matDoc, 0.46, 0.03, 0.62, 0, 0, 0, g);
      for (var l = 0; l < 3; l++) box(matLine, 0.3, 0.006, 0.03, 0, 0.02, -0.16 + l * 0.14, g);
      return g;
    }
    function mini(col) {
      var g = new T.Group();
      for (var m = 0; m < 3; m++) box(m === 1 ? P.metal() : P.graphite(), 0.62, 0.09, 0.46, 0, m * 0.1, 0, g);
      box(P.glow(col, 0.9), 0.4, 0.012, 0.03, 0, 0.3, 0.2, g);
      return g;
    }
    function personGroup() {
      var g = new T.Group();
      var body = new T.Mesh(new T.CapsuleGeometry(0.13, 0.28, 4, 12), matBody); body.position.y = 0.3; g.add(body);
      var head = new T.Mesh(new T.SphereGeometry(0.11, 16, 12), matBody); head.position.y = 0.66; g.add(head);
      c.track(body.geometry, head.geometry); return g;
    }
    var sphereG = new T.SphereGeometry(0.17, 18, 14), coneG = new T.ConeGeometry(0.13, 0.42, 14); c.track(sphereG, coneG);
    var spikeM = P.glow(0xD0607F, 0.7);
    var stampM = P.glow(acc, 0.9);
    function makeItem(i) {
      var g = new T.Group(), kind = 'doc', stamp = null;
      if (key === 'acounteee') { if (i % 3 === 0) { var co = cyl(matCoin, 0.18, 0.035, 0, 0.02, 0, g); } else g.add(docGroup()); stamp = box(stampM, 0.12, 0.012, 0.12, 0.12, 0.04, 0.2, g); }
      else if (key === 'compliance') { g.add(docGroup()); stamp = box(stampM, 0.14, 0.014, 0.14, 0.1, 0.04, 0.2, g); }
      else if (key === 'vendors') {
        if (i % 2) { g.add(docGroup()); box(stampM, 0.1, 0.012, 0.1, -0.15, 0.03, -0.24, g); } else { box(matDoc, 0.4, 0.3, 0.4, 0, 0.15, 0, g); box(matLine, 0.42, 0.02, 0.06, 0, 0.3, 0, g); }
        stamp = cyl(stampM, 0.025, 0.4, 0.0, 0.2, 0.0, g);
      }
      else if (key === 'people') { g.add(personGroup()); stamp = box(stampM, 0.1, 0.1, 0.02, 0, 0.36, 0.13, g); }
      else if (key === 'operations') { box(matDoc, 0.34, 0.34, 0.34, 0, 0.17, 0, g); stamp = box(stampM, 0.2, 0.012, 0.2, 0, 0.345, 0, g); }
      else if (key === 'cyber') {
        if (i % 4 === 0) { var sp = new T.Mesh(coneG, spikeM); sp.position.y = 0.21; g.add(sp); }
        else { var nd = new T.Mesh(sphereG, matCoin); nd.position.y = 0.17; g.add(nd); }
        stamp = new T.Mesh(new T.TorusGeometry(0.2, 0.015, 8, 28), stampM); stamp.rotation.x = Math.PI / 2; stamp.position.y = 0.02; g.add(stamp); c.track(stamp.geometry);
      }
      else if (key === 'suite') { g.add(mini(SUITE[i % 6])); }
      g.userData.stamp = stamp; g.userData.k = i;
      g.castShadow = !c.mobile; scene.add(g); return g;
    }
    for (var n = 0; n < N; n++) {
      var it = makeItem(n);
      var ang = rnd() * Math.PI * 2;
      it.userData.start = new T.Vector3(-4.8 + rnd() * 2.6, 0.5 + rnd() * 2.2, -2.2 + rnd() * 4.4);
      it.userData.rot = new T.Vector3(rnd() * 3, rnd() * 3, rnd() * 3);
      var col = n % 4, row = Math.floor(n / 4);
      var outP;
      if (key === 'suite') outP = new T.Vector3(3.4 + Math.cos(n / 6 * Math.PI * 2) * 1.3, 0.35, Math.sin(n / 6 * Math.PI * 2) * 1.3);
      else if (key === 'people') outP = new T.Vector3(3.0 + col * 0.62, 0.0, -1.0 + row * 0.75);
      else if (key === 'vendors') outP = new T.Vector3(2.9 + col * 0.72, 0.0, -0.9 + row * 0.62);
      else if (key === 'cyber') outP = new T.Vector3(2.9 + col * 0.66, 0.04, -1.0 + row * 0.62);
      else outP = new T.Vector3(3.0 + col * 0.62, 0.05 + (key === 'acounteee' ? row * 0.0 : 0), -0.95 + row * 0.62);
      it.userData.out = outP;
      items.push(it);
    }

    /* port: operations får godkendelsesporte */
    var gates = [];
    if (key === 'operations') {
      [-1.6, -0.7].forEach(function (x) {
        var g = new T.Group(); box(P.metal(), 0.1, 0.9, 0.1, 0, 0.45, -0.5, g); box(P.metal(), 0.1, 0.9, 0.1, 0, 0.45, 0.5, g); box(P.metal(), 0.1, 0.1, 1.1, 0, 0.92, 0, g);
        box(P.glow(acc, 0.8), 0.03, 0.03, 0.9, 0, 0.9, 0, g); g.position.set(x, 0, 0); scene.add(g); gates.push(g);
      });
    }

    /* dashboard (illustration med eksempeldata) */
    var kp = (c.host.getAttribute('data-kpis') || 'A|B|C').split('|');
    var cv = document.createElement('canvas'); cv.width = 640; cv.height = 400; var cg = cv.getContext('2d');
    var hexs = '#' + ('000000' + acc.toString(16)).slice(-6);
    cg.fillStyle = '#10161d'; cg.fillRect(0, 0, 640, 400); cg.strokeStyle = 'rgba(233,232,227,0.18)'; cg.strokeRect(1, 1, 638, 398);
    cg.fillStyle = '#E9E8E3'; cg.font = '500 26px ui-monospace, monospace'; cg.fillText((c.host.getAttribute('data-name') || key).toUpperCase(), 28, 52);
    for (var kq = 0; kq < 3; kq++) {
      var kx = 28 + kq * 200; cg.strokeStyle = 'rgba(233,232,227,0.2)'; cg.strokeRect(kx, 80, 184, 74);
      cg.fillStyle = 'rgba(233,232,227,0.62)'; cg.font = '15px ui-monospace, monospace'; cg.fillText((kp[kq] || '').toUpperCase().slice(0, 16), kx + 12, 106);
      cg.fillStyle = hexs; cg.globalAlpha = 0.75; cg.fillRect(kx + 12, 124, 40 + kq * 28 + 40, 10); cg.globalAlpha = 1;
    }
    cg.strokeStyle = hexs; cg.lineWidth = 3; cg.beginPath(); cg.moveTo(28, 330);
    [[100, 300], [170, 312], [250, 262], [330, 276], [410, 226], [500, 214], [610, 180]].forEach(function (p) { cg.lineTo(p[0], p[1]); }); cg.stroke();
    cg.fillStyle = 'rgba(233,232,227,0.55)'; cg.font = '14px ui-monospace, monospace'; cg.fillText('ILLUSTRATION · EKSEMPELDATA', 28, 378);
    var tex = new T.CanvasTexture(cv); tex.colorSpace = T.SRGBColorSpace; c.track(tex);
    var dashG = new T.Group(); dashG.position.set(4.2, 1.2, -2.15); scene.add(dashG);
    box(P.graphite(), 2.9, 1.9, 0.07, 0, 0, 0, dashG);
    var dm = new T.MeshBasicMaterial({ map: tex, toneMapped: false }); c.track(dm);
    var dp = new T.Mesh(new T.PlaneGeometry(2.7, 1.7), dm); dp.position.z = 0.04; dashG.add(dp); c.track(dp.geometry);

    var AN = { 'in': [-3.6, 1.6, 0], 'mod': [1.15, 1.45, 0.75], 'out': [3.85, 0.7, 0.9], 'dash': [4.2, 2.3, -2.1], 'suite': [3.4, 1.3, 0] };
    function anchor(k, o) { var a = AN[k]; if (!a) return false; o.set(a[0], a[1], a[2]); return true; }

    var PK = [
      [0, [-2.0, 3.4, 10.0], [-1.6, 1.0, 0]],
      [0.22, [-0.8, 3.0, 8.6], [-1.0, 0.9, 0]],
      [0.45, [3.4, 2.6, 6.2], [1.15, 0.8, 0]],
      [0.70, [6.2, 3.0, 7.4], [3.4, 0.8, -0.2]],
      [1.0, [5.0, 4.0, 11.2], [2.2, 1.1, -0.6]]
    ];
    function camera(u, co, to) {
      var Pp = clamp((u + 0.5) / c.SC, 0, 1), i = 0;
      while (i < PK.length - 2 && Pp > PK[i + 1][0]) i++;
      var f = ss((Pp - PK[i][0]) / (PK[i + 1][0] - PK[i][0]));
      for (var q = 0; q < 3; q++) { co[q] = lerp(PK[i][1][q], PK[i + 1][1][q], f); to[q] = lerp(PK[i][2][q], PK[i + 1][2][q], f); }
    }

    function update(u, time) {
      var Pp = clamp((u + 0.5) / c.SC, 0, 1);
      var proc = ss((Pp - 0.34) / 0.1) * (1 - ss((Pp - 0.56) / 0.1));
      for (var i = 0; i < slabs.length; i++) slabs[i].position.y = 0.12 + i * (0.17 + 0.2 * proc * (i / 6));
      strips.forEach(function (m) { m.emissiveIntensity = 0.35 + (0.9 + 0.3 * Math.sin(time * 4)) * proc; });
      var entry = [0.2, 0.6, 0], exit = [2.1, 0.5, 0];
      items.forEach(function (it, k) {
        var ud = it.userData, a = ss((Pp - 0.02 - k * 0.006) / 0.1);
        var ga = ss((Pp - 0.18 - k * 0.010) / 0.22), inA = ss((Pp - 0.38 - k * 0.005) / 0.06);
        var outA = ss((Pp - 0.50 - k * 0.007) / 0.06), mv = ss((Pp - 0.50 - k * 0.010) / 0.22);
        if (outA <= 0) {
          it.position.set(lerp(ud.start.x, entry[0] - 0.9, ga), lerp(ud.start.y + Math.sin(time * 0.8 + k) * 0.08 * (1 - ga), entry[1], ga) + Math.sin(ga * Math.PI) * 0.4, lerp(ud.start.z, entry[2] + ((k % 5) - 2) * 0.06, ga));
          it.scale.setScalar(Math.max(0.0001, a * (1 - inA)));
          it.rotation.set(ud.rot.x * (1 - ga), ud.rot.y * (1 - ga) + ga * 0.0, ud.rot.z * (1 - ga));
        } else {
          it.position.set(lerp(exit[0], ud.out.x, mv), lerp(exit[1], ud.out.y, mv), lerp(exit[2], ud.out.z, mv));
          it.scale.setScalar(Math.max(0.0001, outA)); it.rotation.set(0, 0, 0);
        }
        if (ud.stamp) ud.stamp.scale.setScalar(Math.max(0.0001, ss((Pp - 0.66 - k * 0.004) / 0.08)));
      });
      gates.forEach(function (g, k) { g.children[3].material.emissiveIntensity = 0.4 + 0.6 * Math.max(0, Math.sin(time * 3 - k)); });
      dashG.position.y = lerp(-1.6, 1.2, ss((Pp - 0.78) / 0.16));
      dashG.visible = Pp > 0.7;
    }
    return { camera: camera, update: update, anchor: anchor };
  };

  /* ================================================================== */
  /* FIRMA (forsiden): kernen, porteføljen og tre grunde til at vælge os  */
  /* ================================================================== */
  BUILD.company = function (c) {
    var T = c.THREE, P = c.palette, box = c.box, cyl = c.cyl, scene = c.scene;
    var clamp = c.clamp, lerp = c.lerp, ss = c.ss, lib = c.lib;
    var W = 3.4, Th = 0.2, D = 2.3, N = 7;
    var geoBody = new lib.RoundedBoxGeometry(W, Th, D, 3, 0.03), geoBase = new lib.RoundedBoxGeometry(W + 0.12, Th + 0.04, D + 0.1, 3, 0.03);
    c.track(geoBody, geoBase);
    function buildCore(o) {
      o = o || {};
      var detail = o.detail !== false, accents = o.accents || [0x9be0d3];
      var g = new T.Group(), layers = [];
      for (var i = 0; i < N; i++) {
        var Lr = new T.Group(); Lr.userData.mats = [];
        var use = function (m) { Lr.userData.mats.push(m); return m; };
        var baseMat = (i === 0) ? use(P.ceramic()) : (i === 3 || i === 6) ? use(P.metal()) : use(P.graphite());
        var body = new T.Mesh(i === 6 ? geoBase : geoBody, baseMat); body.castShadow = body.receiveShadow = !c.mobile; Lr.add(body);
        var topY = (i === 6 ? Th + 0.04 : Th) / 2;
        for (var a = 0; a < accents.length; a++) {
          var m2 = use(P.glow(accents[a], 0.85)); var s = box(m2, accents.length > 1 ? 0.16 : 1.1, 0.012, 0.035, accents.length > 1 ? (a - (accents.length - 1) / 2) * 0.2 : 0.5, topY + 0.004, D / 2 - 0.15, Lr);
        }
        if (detail) {
          var peg = use(P.metal());
          [[-1.5, -0.95], [1.5, -0.95], [-1.5, 0.95], [1.5, 0.95]].forEach(function (p) { cyl(peg, 0.045, 0.05, p[0], topY + 0.02, p[1], Lr); });
          var dark = use(P.dark());
          if (i === 0) { box(dark, 1.5, 0.014, 0.9, 0.15, topY + 0.006, -0.15, Lr); }
          else if (i === 1) { [-0.5, 0, 0.5].forEach(function (z) { box(dark, 2.0, 0.014, 0.12, 0.1, topY + 0.004, z - 0.1, Lr); }); }
          else if (i === 2) { cyl(dark, 0.58, 0.014, -0.6, topY + 0.004, -0.1, Lr); cyl(use(P.glow(accents[0], 0.5)), 0.14, 0.02, -0.6, topY + 0.01, -0.1, Lr); }
          else if (i === 3) { var gb = use(P.graphite()); for (var b = 0; b < 6; b++) box(gb, 1.9, 0.022, 0.07, 0.1, topY + 0.011, -0.8 + b * 0.26, Lr); }
          else if (i === 5) { var tm = use(P.metal()); var tor = new T.Mesh(new T.TorusGeometry(0.42, 0.028, 12, 48), tm); tor.rotation.x = Math.PI / 2; tor.position.set(0.2, topY + 0.02, -0.1); Lr.add(tor); c.track(tor.geometry); }
          else if (i === 6) { for (var v = 0; v < 7; v++) box(dark, 1.7, 0.014, 0.035, 0.1, topY + 0.004, -0.75 + v * 0.1, Lr); }
        }
        Lr.userData.top = topY; g.add(Lr); layers.push(Lr);
      }
      return { group: g, layers: layers };
    }
    var main = buildCore({ accents: SUITE }); scene.add(main.group);
    var minis = [], R = 4.7;
    for (var mi = 0; mi < 6; mi++) {
      var mc = buildCore({ detail: false, accents: [SUITE[mi]] });
      var ang = (mi / 6) * Math.PI * 2 + Math.PI / 6;
      mc.home = new T.Vector3(Math.cos(ang) * R, 0, Math.sin(ang) * R * 0.8);
      mc.group.position.copy(mc.home); mc.group.scale.setScalar(0.0001); mc.group.visible = false;
      mc.layers.forEach(function (Lr, k) { Lr.position.y = (N - 1 - k) * Th; });
      scene.add(mc.group); minis.push(mc);
    }
    var tieG = new T.BufferGeometry(); tieG.setAttribute('position', new T.BufferAttribute(new Float32Array(6 * 2 * 3), 3));
    var tieM = new T.LineBasicMaterial({ color: 0x9be0d3, transparent: true, opacity: 0 }); var ties = new T.LineSegments(tieG, tieM); ties.frustumCulled = false; scene.add(ties); c.track(tieG, tieM);

    var K = [
      { cam: [4.4, 2.6, 7.6], tgt: [0, 1.0, 0] },
      { cam: [0, 7.0, 19], tgt: [0, 0.6, 0] },
      { cam: [6.2, 2.6, 17.8], tgt: [0, 1.1, 0] },
      { cam: [7.0, 2.6, 7.0], tgt: [3.0, 0.6, 1.8] },
      { cam: [0, 6.5, 14.0], tgt: [0, 0.5, 0] },
      { cam: [5.0, 3.2, 14.5], tgt: [0, 1.0, 0] }
    ];
    var scn = c.SC;
    function update(u, time) {
      var pm = ss((u - 0.6) / 0.8) * (1 - ss((u - 4.6) / 0.8) * 0.0);
      var ex = ss((u - 1.6) / 0.7) * (1 - ss((u - 2.8) / 0.8));
      var focus = ss((u - 2.6) / 0.6) * (1 - ss((u - 3.6) / 0.6));
      var link = ss((u - 3.6) / 0.7);
      var mainHide = focus * 0.0;
      for (var i = 0; i < N; i++) {
        var ei = ss(clamp((ex - i * 0.08) / 0.52, 0, 1));
        main.layers[i].position.y = (N - 1 - i) * (Th + 0.95 * ei);
        c.dimGroup(main.layers[i], lerp(1, 0.45 + 0.55 * (i === 2 ? 1 : 0.0), ex * 0.0));
      }
      main.group.scale.setScalar(1 - 0.55 * focus + 0.0);
      main.group.position.x = lerp(0, -0.5, focus);
      minis.forEach(function (mc, k) {
        var a = ss(clamp(pm * 1.4 - k * 0.07, 0, 1));
        mc.group.visible = a > 0.001;
        var home = mc.home;
        var tx = lerp(home.x, home.x * 0.62, link), tz = lerp(home.z, home.z * 0.62, link);
        mc.group.position.set(tx, (1 - a) * 2.5, tz);
        var s = Math.max(0.0001, 0.5 * a * (k === 0 ? 1 + 0.5 * focus : 1));
        mc.group.scale.setScalar(s);
        mc.group.rotation.y = k === 0 ? lerp(0, -0.6, focus) : 0;
        mc.layers.forEach(function (Lr, q) { c.dimGroup(Lr, k === 0 ? 1 : 1 - 0.55 * focus); });
      });
      var tp = ties.geometry.attributes.position;
      for (var k2 = 0; k2 < 6; k2++) { var mp = minis[k2].group.position; tp.setXYZ(k2 * 2, 0, 0.6, 0); tp.setXYZ(k2 * 2 + 1, mp.x, 0.5, mp.z); }
      tp.needsUpdate = true; tieM.opacity = 0.2 * pm + 0.6 * link;
      main.group.rotation.y = Math.sin(time * 0.25) * 0.05 + (u > 4.2 ? (u - 4.2) * 0.35 : 0);
    }
    function anchor(k, o) {
      if (k === 'main') { o.set(0, 2.6 + 0.0, 0); return true; }
      if (k.indexOf('mini:') === 0) { var m = minis[+k.slice(5)]; if (!m) return false; o.set(m.group.position.x, 1.0, m.group.position.z); return true; }
      if (k === 'core') { o.set(1.9, 0.9, 0.4); return true; }
      return false;
    }
    return { K: K, update: update, anchor: anchor };
  };

  /* ---------- start og Shopify-editor ---------- */
  function scan(root) { [].forEach.call((root || document).querySelectorAll('[data-stage]'), function (h) { boot(h); }); }
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-stage]'), function (h) {
      var inst = instances.get(h); if (inst && inst.destroy) inst.destroy(); instances.delete(h);
    });
  });
  window.__skauStage = { instances: instances };
})();
